__turbopack_context__.v({
  "card": "MetricStatGridWidget-module__ykqNuq__card",
  "grid": "MetricStatGridWidget-module__ykqNuq__grid",
  "icon": "MetricStatGridWidget-module__ykqNuq__icon",
  "label": "MetricStatGridWidget-module__ykqNuq__label",
  "labelRow": "MetricStatGridWidget-module__ykqNuq__labelRow",
  "link": "MetricStatGridWidget-module__ykqNuq__link",
  "meta": "MetricStatGridWidget-module__ykqNuq__meta",
  "value": "MetricStatGridWidget-module__ykqNuq__value",
});
